import "./styles.css";
import { Container, Grid, Stack } from "@mui/material";

import BlockedUser from "@/Auth/components/Blockers/BlockedUser";
import Header from "@Layouts/views/Header";
import Footer from "@Layouts/views/Footer";
import { WrapperLayerProvider } from "@/Common/context/wrapperLayer/WrapperLayerContext";
import { ReactNode } from "react";
import InactivityDialog from "@/Layouts/components/InactivityDialog";

interface PageLayerProps {
	title?: ReactNode;
	icon?: string | ReactNode;
	children: ReactNode;
	align?: string;
	headerSideComponent?: ReactNode;
	isDisabled?: boolean;
}

function PageLayer(props: Readonly<PageLayerProps>) {
	const { children, title, icon, align, isDisabled = false } = props;

	return (
		<>
			<InactivityDialog />
			<Stack>
				<BlockedUser />
				<WrapperLayerProvider value={{ isDisabled }}>
					<Header title={title} icon={icon} align={align} topRightComponent={props.headerSideComponent} />
				</WrapperLayerProvider>
				<Stack>
					<Container id="main-area" className="main-area" disableGutters maxWidth={false}>
						<Grid container direction="column" alignItems="center">
							<Grid item className="content-main content-size">
								<Grid container position="relative" sx={{ minHeight: "400px" }}>
									{children}
								</Grid>
							</Grid>
							<Grid item sx={{ width: "1410px" }}>
								<Footer />
							</Grid>
						</Grid>
					</Container>
				</Stack>
			</Stack>
		</>
	);
}

export default PageLayer;
